// migrated 1:1 from @nexato/nx-core-module, #688
import { Activity } from "../../../entities/activity/activity";
import { ActivityComponent } from "./activityComponent";
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-issue-closed',
  template: `
    Geschlossen von <b>{{activity()?.actor?.displayName}}</b> <app-relative-time [timestamp]="activity()?.createdDateTime" />
  `
})
export class IssueClosedComponent implements ActivityComponent {

  readonly activity = input.required<Activity>();
  readonly ownerId = input<string>();
}
